import { Link } from "react-router-dom";
import "../Styles/Footer.css";

/**
 * Sidfot med de juridiska länkarna.
 *
 * Ligger på inloggning, registrering, inställningar och de publika
 * sidorna. Terms och Privacy måste gå att nå utan konto — det är hela
 * poängen med att de är publika routes och inte text i en modal bakom
 * inloggningen.
 */
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <nav className="site-footer-links" aria-label="Legal">
        <Link to="/terms">Terms</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/contact">Contact</Link>
      </nav>

      <p className="site-footer-copy">© {year} Beatspot</p>
    </footer>
  );
}
